import { render, staticRenderFns } from "./EditorToolbar.vue?vue&type=template&id=7f5e70ec&scoped=true&"
import script from "./EditorToolbar.vue?vue&type=script&lang=js&"
export * from "./EditorToolbar.vue?vue&type=script&lang=js&"
import style0 from "./EditorToolbar.vue?vue&type=style&index=0&id=7f5e70ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5e70ec",
  null
  
)

export default component.exports